module.exports = require('./helpers/bundle-url').getBundleURL('hstjT') + "phone-solid-white.2cd74882.svg";